export default function messageOnGetMiniAppInfo(status) {
    let message

    switch (status) {
        case 503:
            message = 'Ops! Ocorreu um problema com a internet e não conseguimos obter os dados do eitri-app.'
            break
        default:
            message =
                'Ops! Algo de estranho ocorreu e não conseguimos obter os dados do eitri-app. Por favor, tente novamente mais tarde.'
    }
    return message
}
